import $ from 'jquery';
import * as registry from '../../../home24/core/registry';
import * as config from '../../../home24/core/config';
import HelpAreaChat from './chat';
import HelpAreaFallback from './fallback';

export default function HelpArea() {
  this.onLoad = this.onLoad.bind(this);
  this.snapEngageID = registry.get('snapEngageID');
  this.timeoutId = null;

  if (this.snapEngageID) {
    var url = config.get('snapEngage.url').replace('%1', this.snapEngageID);

    $.getScript(url).done(this.onLoad);
  } else {
    this.showFallback();
  }
}

$.extend(HelpArea.prototype, {
  onLoad: function() {
    var self = this;

    window.SnapEngage.getAgentStatusAsync(function(online) {
      if (online) {
        self.showChat();
      } else {
        self.showFallback();
      }
    });
  },

  showChat: function() {
    this.helpAreaChat = new HelpAreaChat();
  },

  showFallback: function() {
    if (this.isFallbackEnabled()) {
      this.helpAreaFallback = new HelpAreaFallback({
        $container: this.$container,
        template: this.fallbackTemplate
      });
    }
  },

  isFallbackEnabled: function() {
    return registry.get('currentLayout') !== 'checkout';
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/helparea/helparea.js
 **/